import React from 'react';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import useFilterItemsWithAmount from '../../../hooks/useFilterItemsWithAmount';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import useRequestServiceCompaniesStreets from '../../../../../queries/useRequestServiceCompaniesStreets';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';
import { Tooltip } from 'antd';

const companiesFilter = filtersData[filterNames.companies];
const filter = filtersData[filterNames.streets];

const StreetsFilter = ({ disabled = false }) => {
  const [filterState, setFilterState] = useFilterState(filter);
  const [companiesFilterState] = useFilterState(companiesFilter);

  const { data, isFetching } = useRequestServiceCompaniesStreets(
    companiesFilterState,
    {
      enabled: companiesFilterState.length > 0,
      staleTime: Infinity,
    }
  );

  const { items, itemsMap } = useFilterItemsWithAmount({
    data,
    requestKey: 'streetId',
  });

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);

    setFilterState(newState);
  };

  const hasFilter = filterState.length > 0;

  const allSelected = hasFilter && itemsMap.size === filterState.length;

  const filteredItems = items.filter((item) => filterState.includes(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      <Tooltip title={!companiesFilterState.length ? 'Выберите УК' : ''}>
        <div>
          <FilterDropdown
            disabled={isFetching || disabled || !companiesFilterState.length}
            filter={filter}
            multiple
            items={items}
            getItemContent={(item) => item.name}
            getSearchContent={(item) => item.name}
            renderButton={({ visible }) => (
              <FilterButton
                text="Улица"
                opened={visible}
                selected={hasFilter}
              />
            )}
          />
        </div>
      </Tooltip>
      {allSelected ? (
        <SelectedOption
          text="Все"
          onRemove={() => setFilterState([])}
        />
      ) : (
        <>
          {visibleItems.map((item) => (
            <SelectedOption
              key={item.id}
              text={item.name}
              value={item.id}
              onRemove={handleItemRemove}
            />
          ))}
          {Array.isArray(hiddenItems) && !!hiddenItems.length && (
            <HiddenSelectedOptions
              hiddenItems={hiddenItems}
              handleItemRemove={handleItemRemove}
            />
          )}
        </>
      )}
    </FilterContainer>
  );
};

export default StreetsFilter;
